export interface Workbook {
  number: string;
  title: string;
  subtitle: string;
  description: string;
  tag: string;
  coverImage: string;
}

export const workbooks: Workbook[] = [
  {
    number: '01',
    title: 'MATIÈRE, SOLUTIONS & STRUCTURE ATOMIQUE',
    subtitle: 'De l’observation au modèle : états, transformations, mélanges, solutions et atomes',
    description:
      'Un volume visuel et progressif sur la matière, ses états, ses transformations, les mélanges, les solutions et la concentration, jusqu’à la structure atomique, les atomes et les ions. Les schémas et les représentations accompagnent le passage de l’observation à la représentation, puis au modèle.',
    tag: '60 pages · Schémas · Fiches visuelles · Activités · Exercices',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/8caDorKeGTSgTZgcUq1M8Z/ChatGPT_Image_17_ago_2026,_08_33_35_p.m._(1).png',
  },
  {
    number: '02',
    title: 'STRUCTURE MOLÉCULAIRE, LIAISONS & PROPRIÉTÉS',
    subtitle: 'Représentations de Lewis, géométrie, polarité, interactions et propriétés',
    description:
      'Des représentations visuelles pour accompagner l’explication des structures et des liaisons : schémas de Lewis, géométrie des molécules, polarité, interactions et propriétés liées aux structures chimiques. Les comparaisons visuelles rendent ces notions abstraites plus faciles à présenter en classe.',
    tag: '60 pages · Représentations moléculaires · Comparaisons visuelles · Activités',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/nP7K7TfTKy9rvXaxQKRAxw/ChatGPT_Image_17_ago_2026,_08_33_35_p.m._(2).png',
  },
  {
    number: '03',
    title: 'TRANSFORMATIONS CHIMIQUES, STŒCHIOMÉTRIE & TITRAGES',
    subtitle: 'Équations, quantité de matière, calculs, réactif limitant, dosages et titrages',
    description:
      'Comprendre la transformation, la représenter, la quantifier, puis l’exploiter : équations de réaction, quantité de matière, masse molaire, relations quantitatives, réactif limitant, solutions, dosages et titrages. Les étapes de résolution sont organisées visuellement pour être projetées ou distribuées.',
    tag: '60 pages · Étapes de résolution · Tableaux synthétiques · Exercices',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/3eMNUhF4APY8sQMJheaVd9/ChatGPT_Image_17_ago_2026,_08_33_35_p.m._(3).png',
  },
  {
    number: '04',
    title: 'ANALYSE, ACIDE-BASE, CINÉTIQUE & ÉQUILIBRES',
    subtitle: 'Couples acide/base, pH, titrages, facteurs cinétiques et évolution des systèmes',
    description:
      'Des supports directement exploitables pour l’analyse chimique, les réactions acide-base, les couples acide/base, le pH, les titrages, la cinétique et ses facteurs, l’évolution d’un système et les équilibres. Les données expérimentales et l’interprétation des résultats sont présentées sous forme de tableaux et de schémas prêts à utiliser.',
    tag: '60 pages · Schémas · Tableaux de données · Activités · Exercices',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/8QxCWb2UUFPh4q7Zn4dLcQ/ChatGPT_Image_17_ago_2026,_08_33_36_p.m._(4).png',
  },
  {
    number: '05',
    title: 'CHIMIE ORGANIQUE & STRATÉGIES DE SYNTHÈSE',
    subtitle: 'Structures carbonées, nomenclature, groupes caractéristiques, réactions et synthèse',
    description:
      'Reconnaître, représenter, interpréter, transformer, puis élaborer une stratégie : structures carbonées, représentations, nomenclature, groupes caractéristiques, transformations organiques, identification des espèces, réactions, protocoles et stratégies de synthèse, avec l’analyse des résultats.',
    tag: '60 pages · Représentations · Protocoles · Activités · Exercices',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/5CcSzZm7BBRCnq7yPWJ49K/ChatGPT_Image_17_ago_2026,_08_33_36_p.m._(5).png',
  },
];

export interface Bonus {
  badge: string;
  icon: string;
  title: string;
  subtitle: string;
  description: string;
  pages: string;
}

export const bonuses: Bonus[] = [
  {
    badge: 'RESSOURCE 1',
    icon: '🗂️',
    title: 'SÉQUENCES DE COURS PRÊTES À L’EMPLOI™',
    subtitle: 'Ouvrez. Choisissez. Adaptez. Enseignez.',
    description:
      '18 séquences déjà structurées, avec leur déroulement et les supports associés, pour réduire le temps de construction d’une séance. Vous sélectionnez ce qui vous convient, vous adaptez, vous imprimez ou vous projetez : rien ne vous oblige à suivre une séquence telle quelle.',
    pages: '40 pages · 18 séquences',
  },
  {
    badge: 'RESSOURCE 2',
    icon: '📝',
    title: 'ÉVALUATIONS & CONTRÔLES PRÊTS À L’EMPLOI™',
    subtitle: 'Préparez vos contrôles sans tout reconstruire',
    description:
      'Évaluations, contrôles et exercices, avec versions A/B lorsqu’elles sont disponibles, barèmes et corrigés. L’intérêt n’est pas d’avoir plus d’exercices, mais de ne plus recréer chaque évaluation à partir de zéro et de corriger de façon mieux structurée.',
    pages: '50 pages',
  },
  {
    badge: 'RESSOURCE 3',
    icon: '🎯',
    title: 'DIFFÉRENCIATION & REMÉDIATION EXPRESS™',
    subtitle: 'Une notion. Trois niveaux. Rien à recréer.',
    description:
      '8 parcours qui reprennent une même notion selon trois niveaux de maîtrise, pour différencier, revenir sur un point précis ou proposer un entraînement adapté. Utilisable rapidement, sans préparation supplémentaire.',
    pages: '35 pages · 8 parcours',
  },
  {
    badge: 'RESSOURCE 4',
    icon: '⏱️',
    title: 'ACTIVITÉS EXPRESS 10–15 MIN™',
    subtitle: 'Ouvrez. Imprimez. Utilisez.',
    description:
      '24 activités courtes et visuelles de 10 à 15 minutes : mise en route, réactivation, entraînement, consolidation, révision ou fin de séance. Corrigés inclus lorsqu’ils sont prévus, pour une utilisation ponctuelle sans préparer une séance entière.',
    pages: '35 pages · 24 activités',
  },
];

export interface Testimonial {
  text: string;
  name: string;
  role: string;
  initials: string;
}

export const testimonials: Testimonial[] = [
  {
    text: 'Ce que j’apprécie le plus, c’est le temps gagné en préparation. Avant un cours, il m’arrivait de chercher des fiches, des exercices et des schémas dans des sources différentes. Avec des ressources déjà organisées, je choisis ce dont j’ai besoin et je me concentre bien davantage sur le cours et sur la classe.',
    name: 'Élena R.',
    role: 'Professeure de physique-chimie',
    initials: 'ER',
  },
  {
    text: 'La partie visuelle est particulièrement utile quand je dois expliquer la structure atomique, les liaisons ou les transformations chimiques. Avoir des schémas clairs sous les yeux des élèves rend l’explication plus immédiate et me permet de reprendre rapidement une notion.',
    name: 'Marc B.',
    role: 'Professeur de physique-chimie',
    initials: 'MB',
  },
  {
    text: 'Les évaluations en plusieurs versions et leurs corrigés simplifient nettement l’organisation, surtout quand on travaille avec plusieurs classes. Pendant la correction aussi, disposer d’un barème clair permet de travailler de façon beaucoup plus ordonnée.',
    name: 'Julie F.',
    role: 'Professeure de physique-chimie',
    initials: 'JF',
  },
  {
    text: 'J’aime surtout pouvoir choisir le support en fonction de la classe. Une fois c’est une explication, une autre fois une fiche, une activité ou une évaluation. Le fait que tout soit classé par notion rend la recherche beaucoup plus rapide.',
    name: 'Françoise C.',
    role: 'Professeure de physique-chimie',
    initials: 'FC',
  },
  {
    text: 'Les activités permettent de passer de l’explication à la pratique sans devoir tout préparer à chaque fois. Elles sont aussi utiles pour repérer assez vite ce qui doit être repris avec les élèves.',
    name: 'Luc D.',
    role: 'Professeur de physique-chimie',
    initials: 'LD',
  },
  {
    text: 'Les activités courtes fonctionnent bien en début ou en fin de séance. Le rythme du cours change, mais le contenu de chimie reste central. C’est aussi une manière intéressante d’impliquer des élèves qui participent moins d’habitude.',
    name: 'Sarah M.',
    role: 'Professeure de physique-chimie',
    initials: 'SM',
  },
  {
    text: 'Les fiches et les représentations visuelles sont très pratiques pendant les explications et lorsqu’il faut revenir rapidement sur une notion déjà traitée. L’essentiel est qu’elles restent claires et pas surchargées, pour que les élèves puissent vraiment s’en servir comme référence.',
    name: 'Alexandre G.',
    role: 'Professeur de physique-chimie',
    initials: 'AG',
  },
];

export interface Highlight {
  title: string;
  detail: string;
}

/**
 * Rappels informatifs affichés dans l’encart flottant.
 * Uniquement des caractéristiques vérifiables de la bibliothèque, aucune donnée d’achat.
 */
export const highlights: Highlight[] = [
  {
    title: 'Accès numérique immédiat',
    detail: 'Vous recevez les ressources par e-mail juste après le paiement.',
  },
  {
    title: 'Paiement unique',
    detail: 'Aucun abonnement mensuel, aucun renouvellement automatique.',
  },
  {
    title: '460 pages prêtes à imprimer',
    detail: '5 volumes pédagogiques et 4 ressources complémentaires.',
  },
  {
    title: 'Ressources très visuelles',
    detail: 'Schémas, représentations et fiches faciles à projeter.',
  },
  {
    title: 'Corrigés inclus',
    detail: 'Évaluations et contrôles accompagnés de leurs barèmes.',
  },
  {
    title: 'Accès à vie',
    detail: 'Vous réutilisez les ressources année après année.',
  },
];

export interface Faq {
  question: string;
  answer: string;
}

export const faqs: Faq[] = [
  {
    question: 'S’agit-il d’un abonnement ?',
    answer:
      'Non. Il s’agit d’un paiement unique de 19 €. Aucun abonnement mensuel et aucun renouvellement automatique.',
  },
  {
    question: 'Que vais-je recevoir exactement ?',
    answer:
      'L’accès numérique aux 5 volumes pédagogiques (60 pages chacun) et aux 4 ressources complémentaires : Séquences de cours prêtes à l’emploi™ (40 pages, 18 séquences), Évaluations & contrôles prêts à l’emploi™ (50 pages), Différenciation & remédiation express™ (35 pages, 8 parcours) et Activités express 10–15 min™ (35 pages, 24 activités). Soit 460 pages au total.',
  },
  {
    question: 'Comment vais-je recevoir les ressources ?',
    answer:
      'L’accès est envoyé à l’adresse e-mail indiquée lors du paiement, juste après l’achat. Pensez à vérifier vos dossiers spam et promotions si le message n’apparaît pas immédiatement.',
  },
  {
    question: 'Puis-je conserver les ressources ?',
    answer:
      'Oui. L’accès aux ressources numériques comprises dans l’offre est à vie : vous pouvez les réutiliser année après année.',
  },
  {
    question: 'Puis-je imprimer ou projeter les ressources ?',
    answer:
      'Oui. Les fichiers sont au format PDF et conçus pour être imprimés, projetés ou distribués. Vous pouvez n’imprimer que les pages utiles à la séance du jour.',
  },
  {
    question: 'Le matériel est-il destiné aux professeurs de physique-chimie ?',
    answer:
      'Oui. La bibliothèque est pensée pour faciliter la préparation, l’explication, la pratique, la différenciation et l’évaluation en chimie. Les ressources sont classées par notion et par usage, et s’adaptent à différentes progressions.',
  },
  {
    question: 'Est-ce une formation ou un cours en vidéo ?',
    answer:
      'Non. CHIMIE VISUELLE™ est une bibliothèque de ressources pédagogiques numériques : ni formation, ni vidéo, ni logiciel, ni application. Vous choisissez les supports et vous gardez votre façon d’enseigner.',
  },
  {
    question: 'Les ressources sont-elles vraiment visuelles ?',
    answer:
      'Oui. Schémas, tableaux synthétiques, représentations moléculaires, comparaisons visuelles et étapes de résolution organisées constituent la base des volumes : une grande partie du travail visuel est déjà faite.',
  },
  {
    question: 'J’utilise déjà mes propres supports. Est-ce compatible ?',
    answer:
      'Oui. Rien ne remplace ce que vous utilisez déjà. Vous pouvez vous appuyer sur l’ensemble de la bibliothèque ou n’intégrer que les séquences, activités, évaluations et fiches qui vous manquent.',
  },
  {
    question: 'S’agit-il d’un produit physique ?',
    answer: 'Non. Tout est numérique : aucun envoi postal n’est effectué.',
  },
  {
    question: 'Puis-je utiliser les ressources avec mes élèves ?',
    answer:
      'Oui. La licence est individuelle et couvre l’utilisation dans les classes de l’enseignant qui effectue l’achat. La redistribution, le partage intégral et la revente des ressources ne sont pas autorisés.',
  },
  {
    question: 'Les ressources sont-elles entièrement en français ?',
    answer: 'Oui. Textes, activités, évaluations et corrigés sont entièrement en français.',
  },
  {
    question: 'Faut-il installer une application ?',
    answer:
      'Non. Les fichiers sont en PDF et s’ouvrent sur n’importe quel ordinateur, tablette ou téléphone, sans application obligatoire.',
  },
  {
    question: 'Puis-je demander un remboursement ?',
    answer:
      'Oui. Vous pouvez nous contacter dans les sept jours suivant l’achat et demander un remboursement selon les conditions indiquées dans notre politique de remboursement.',
  },
];
